import {UploadFile} from "antd/lib/upload/interface";
import {
    RemoveSelectedFileAction,
    RemoveSelectedFilesAction,
    SetFinishedUploadsAction,
    SetSelectedFilesAction,
} from "../../interfaces/store/actions/uploadFiles";
import {
    REMOVE_SELECTED_FILE,
    REMOVE_SELECTED_FILES,
    SET_FINISHED_UPLOADS,
    SET_SELECTED_FILES,
} from "../actions/availableActions";
import {SelectedFiles, UploadFilesState} from "../../interfaces/store/reducers/uploadFilesState";
import {removeFileFromBucket} from "../../utils/common";

const initialState: UploadFilesState = {
    selectedFiles: {},
    finishedUploads: {
        bucketCount: {},
        finishedTaskIds: [],
    },
};

type AvailableActions = SetSelectedFilesAction
| RemoveSelectedFileAction
| SetFinishedUploadsAction
| RemoveSelectedFilesAction;

const uploadFilesReducer = (state: UploadFilesState = initialState, action: AvailableActions): UploadFilesState => {
    switch (action.type) {
        case SET_SELECTED_FILES: {
            return {...state, selectedFiles: action.payload};
        }
        case REMOVE_SELECTED_FILE: {
            return {
                ...state,
                selectedFiles: removeFileFromBucket(action.payload, state.selectedFiles),
            };
        }
        case SET_FINISHED_UPLOADS: {
            return {...state, finishedUploads: action.payload};
        }
        case REMOVE_SELECTED_FILES: {
            let selectedFiles: SelectedFiles = {...state.selectedFiles};
            action.payload.forEach((uploadFile: UploadFile) => {
                selectedFiles = removeFileFromBucket(uploadFile, selectedFiles);
            });
            return {
                ...state,
                selectedFiles,
            };
        }
        default:
            return state;
    }
};

export default uploadFilesReducer;
